export default __webpack_public_path__ + "static/media/person.886e4a77.jpg";